import React from 'react';
import PropTypes from 'prop-types';
import registeredComponent from 'utils/registeredComponent';

import './styles/TotalsHeader.scss';

/** Used to display totals atop a contact list. Primarily used for billing totals. */

const TotalsHeader = ({ columnHeaders, columnValues }) => {
  const columnDivs = columnHeaders.map((columnHeader, index) => (
    <div key={columnHeader}>
      <div className='totals-header'>{columnHeader}</div>
      <div className='totals-value'>{columnValues[index]}</div>
    </div>
  ));

  return (
    <div className='totals-component-wrapper'>
      <div className='totals-component'>
        {columnDivs}
      </div>
    </div>
  );
};

TotalsHeader.propTypes = {
  /** Header for the section */
  columnHeaders: PropTypes.arrayOf(PropTypes.string).isRequired,

  /** Value for the section */
  columnValues: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default registeredComponent('TotalsHeader')(TotalsHeader);
